// extracted by mini-css-extract-plugin
export default {"durationContainer":"W8cbV__durationContainer","durationLabel":"p2bXN__durationLabel","scrollableContainer":"OX2cL__scrollableContainer"};